import ViewModePage from './ViewModePage.container';

export default ViewModePage;
